(() => {
  // Run after DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    const input = document.getElementById('gmeta-search');
    const acc   = document.getElementById('glossaryAccordion');
    const letterLinks = document.querySelectorAll('.glossary-letter');

    if (!acc) return; // not on glossary markup

    const normalize = (str) => (str || '').toLowerCase().trim();

    function setExpanded(el, expand){
      const col = el.querySelector('.accordion-collapse');
      if (!col) return;
      const collapse = (window.bootstrap && window.bootstrap.Collapse)
        ? window.bootstrap.Collapse.getOrCreateInstance(col, { toggle:false })
        : null;
      if (expand) (collapse ? collapse.show() : col.classList.add('show'));
      else        (collapse ? collapse.hide() : col.classList.remove('show'));
    }

    // Search filter
    input && input.addEventListener('input', function(){
      const q = normalize(this.value);
      acc.querySelectorAll('[data-glossary-item]').forEach(item => {
        const term  = normalize(item.querySelector('.term-text')?.textContent);
        const badge = normalize(item.querySelector('.badge')?.textContent);
        const body  = normalize(item.querySelector('.accordion-body')?.textContent);
        const match = !q || term.includes(q) || badge.includes(q) || body.includes(q);
        item.style.display = match ? '' : 'none';
        if (q && match) setExpanded(item, true);
        if (!q)         setExpanded(item, false);
      });
    });

    // Letter filter
    letterLinks.forEach(link => {
      link.addEventListener('click', function(e){
        e.preventDefault();
        const letter = this.dataset.letter;
        if (input) input.value = ''; // clear search
        acc.querySelectorAll('[data-glossary-item]').forEach(item => {
          const itemLetter = item.dataset.letter;
          const show = (letter === 'all') || (itemLetter === letter);
          item.style.display = show ? '' : 'none';
          setExpanded(item, false);
        });
      });
    });
  }
})();